import { Redirect } from 'react-router-dom-v5'
import { AiPurchaseOrderPageShell } from '../../fp-b2b-shared/ai-purchase-order/components/AiPurchaseOrderPageShell/AiPurchaseOrderPageShell'
import { useButler } from '../../fp-b2b-shared/ai-purchase-order/components/ButlerProvider/useButler'
import { useStmQuickOrderStore } from '../hooks'
import { CsvRecommendationContent } from './components/CsvRecommendation/CsvRecommendationContent'

export const StmCsvRecommendations = () => {
  const { routes } = useButler()
  const hasCsvItems = useStmQuickOrderStore(state => state.csv.items.length > 0)

  if (!hasCsvItems) return <Redirect to={routes.entry} />

  return (
    <AiPurchaseOrderPageShell>
      <CsvRecommendationContent />
    </AiPurchaseOrderPageShell>
  )
}
